import { createFeature, createReducer, on } from '@ngrx/store';
import { AccountingPeriodsModel } from '@shared/data-access/models';
import { AccountingPeriodsAction } from '../actions';

export const featureName = 'accountingPeriods';

export interface AccountingPeriodsState {
  item: AccountingPeriodsModel | null;
}
export const initialState: AccountingPeriodsState = {
  item: null,
};
export const accountingPeriodsFeature = createFeature({
  name: featureName,
  reducer: createReducer(
    initialState,
    on(AccountingPeriodsAction.loadItemSuccess, (state, prop: { item: AccountingPeriodsModel }) => ({ ...state, item: prop.item }))
  ),
});

export const {
  name, // feature name
  reducer, // feature reducer
} = accountingPeriodsFeature;
